
import on_domready from "domready"

import {
  requestIdleCallback,
} from "plugins/request-animation-frame-polyfill"

import Collapsible from "./collapsible"
import DataToggleableTriggersAndTargets from "./data-toggleable-triggers-and-targets"
import JsScrollspyNavbar from "./js-scrollspy-navbar"
import JsSmoothScrollingNavbar from "./js-smooth-scrolling-navbar"
import ToggleDisplay from "./toggle-display"
import Toggleable from "./toggleable"
import ImageLazyLoading from "widgets/image_lazyloading"
import BackgroundImageLazyloading from "widgets/background_image_lazyloading"


const onLoad = () => {
  on_domready(() => {
    Collapsible.onLoad()
    DataToggleableTriggersAndTargets.onLoad()
    JsScrollspyNavbar.onLoad()
    JsSmoothScrollingNavbar.onLoad()
    ToggleDisplay.onLoad()
    Toggleable.onLoad()

    requestIdleCallback(() => {
      BackgroundImageLazyloading.default_lazyload_instance().update()
      // Not calling `update` on initialization
      ImageLazyLoading.default_lazyload_instance()
    })
  })
}


export {
  onLoad,
}
